<div class="sonnet-four-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close Sonnet 4 Info">
    ×
  </button>

  <div class="sonnet-header">
    <img src="assets/logos/anthropic.svg" alt="Sonnet 4.5 Logo" class="sonnet-logo" />
    <h2>Sonnet 4.5</h2>
    <div class="sonnet-sub">Refined Balance by Anthropic</div>
  </div>

  <div class="sonnet-body">
    <p>
      <strong>Sonnet 4.5</strong> is Anthropic’s “sweet spot” model—built to feel premium in real products
      without demanding flagship-level compute. It’s designed for teams that need
      <strong>consistent reasoning</strong>, <strong>great writing</strong>, and <strong>stable behavior</strong>
      across high-volume, user-facing workflows.
    </p>

    <p>
      Where lightweight models can feel brittle and flagship models can be overkill, Sonnet 4.5 focuses on
      dependable performance: it follows instructions cleanly, keeps tone aligned, and stays coherent over multi-turn conversations.
      It’s especially strong for assistants, internal copilots, and workflows that mix
      <strong>analysis + communication</strong> (summaries, decisions, recommendations, and drafts).
    </p>

    <ul>
      <li>⚡ <strong>Fast, “feels instant” UX:</strong> Responsive answers with a high bar for clarity and flow.</li>
      <li>🧠 <strong>Reliable reasoning:</strong> Strong multi-step handling, constraints, and instruction adherence.</li>
      <li>🗣️ <strong>Conversation-first intelligence:</strong> Great at follow-ups, intent tracking, and context continuity.</li>
      <li>🎯 <strong>Tone + style control:</strong> Excellent for brand voice, professional writing, and audience-aware output.</li>
      <li>🧾 <strong>Summarization &amp; synthesis:</strong> Turns messy notes, threads, and long text into structured output.</li>
      <li>🧩 <strong>Structure-friendly outputs:</strong> Clean bullets, checklists, tables, and predictable formats for UI + automation.</li>
      <li>🛡️ <strong>Production-ready guardrails:</strong> Safer, steadier behavior for repeatable, brand-safe outputs.</li>
      <li>💰 <strong>Cost-to-quality sweet spot:</strong> Near-flagship feel for many tasks without Opus-level overhead.</li>
    </ul>

    <div class="when-optimal">
      <h3>When is Sonnet 4.5 optimal?</h3>
      <ul>
        <li>Customer support + assistants where speed, trust, and tone consistency matter</li>
        <li>Business writing: emails, proposals, policies, enablement, and executive summaries</li>
        <li>Product copilots: guided workflows needing predictable formatting and instruction-following</li>
        <li>Summarization + extraction: docs, calls, tickets, and long threads into action items</li>
        <li>Brainstorming + refinement: ideation, rewriting, and polishing while staying on-brief</li>
        <li>General coding help: explanations, refactors, and lightweight debugging support</li>
        <li>When Opus-level depth isn’t needed, but quality must remain high</li>
      </ul>
    </div>

    <p>
      In short: choose <strong>Sonnet 4.5</strong> when you want a model that’s strong everywhere—reasoning, writing,
      conversation, and structure—while staying efficient enough for production scale.
    </p>
  </div>
</div>
